import { createContext, useContext, useMemo } from 'react'
import { useConfig } from '../config'

const StoreContext = createContext()

const EMPTY_VALUE = {}

const StoreProvider = ({ children, storeCode }) => {
	const { availableStores } = useConfig()

	const details = useMemo(
		() => availableStores?.find(({ code }) => code === storeCode) ?? EMPTY_VALUE,
		[availableStores, storeCode]
	)

	return <StoreContext.Provider value={details}>{children}</StoreContext.Provider>
}

export default StoreProvider
export const useStore = () => useContext(StoreContext)
